import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navClass = ({ isActive }) =>
  isActive
    ? "text-[#A43032] font-semibold"
    : "text-[#010101]/85 hover:text-[#A43032] transition-colors";

export function MarketingNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b-2 border-[#010101] bg-white shadow-sm">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link
          to="/"
          className="group flex min-w-0 items-center gap-3"
          onClick={() => setOpen(false)}
        >
          <img
            src="/raguia.webp"
            alt="Raguia — accueil"
            className="h-9 w-auto shrink-0 object-contain sm:h-10"
            width={160}
            height={40}
          />
          <span className="hidden font-heading font-bold tracking-tight text-[#010101] sm:inline">
            Raguia
          </span>
        </Link>

        <nav
          className="hidden items-center gap-8 text-m md:flex"
          aria-label="Navigation principale"
        >
          <NavLink to="/" end className={navClass}>
            Accueil
          </NavLink>
          <NavLink to="/valeurs" className={navClass}>
            Valeurs
          </NavLink>
          <NavLink to="/comparatif" className={navClass}>
            Comparatif
          </NavLink>
          <NavLink to="/tarifs" className={navClass}>
            Tarifs
          </NavLink>
          <NavLink to="/contact" className={navClass}>
            Contact
          </NavLink>
          <NavLink to="/blog" className={navClass}>
            Blog
          </NavLink>
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/contact"
            className="rounded-full bg-[#A43032] px-4 py-2 text-sm font-semibold text-white shadow-md shadow-[#A43032]/30 transition hover:brightness-95"
          >
            Demander une démo
          </Link>
        </div>

        <button
          type="button"
          className="inline-flex rounded-xl border-2 border-[#010101]/15 bg-white p-2 text-[#010101] md:hidden"
          aria-expanded={open}
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? (
            <X className="size-6" aria-hidden />
          ) : (
            <Menu className="size-6" aria-hidden />
          )}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#010101]/10 bg-white p-4 md:hidden">
          <nav
            className="flex flex-col gap-3 text-sm font-medium"
            aria-label="Navigation mobile"
          >
            <NavLink
              to="/"
              end
              className={navClass}
              onClick={() => setOpen(false)}
            >
              Accueil
            </NavLink>
            <NavLink
              to="/valeurs"
              className={navClass}
              onClick={() => setOpen(false)}
            >
              Valeurs
            </NavLink>
            <NavLink
              to="/blog"
              className={navClass}
              onClick={() => setOpen(false)}
            >
              Blog
            </NavLink>
            <NavLink
              to="/comparatif"
              className={navClass}
              onClick={() => setOpen(false)}
            >
              Comparatif
            </NavLink>
            <NavLink
              to="/tarifs"
              className={navClass}
              onClick={() => setOpen(false)}
            >
              Tarifs
            </NavLink>
            <NavLink
              to="/contact"
              className={navClass}
              onClick={() => setOpen(false)}
            >
              Contact
            </NavLink>
            <Link
              to="/contact"
              className="mt-2 rounded-full bg-[#A43032] py-2.5 text-center text-sm font-semibold text-white"
              onClick={() => setOpen(false)}
            >
              Demander une démo
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
